<template>
  <ValidationProvider
    v-slot="{ errors }"
    :name="name"
    :rules="rules"
    :vid="vid"
    class="w-100">
    <BaseTextField
      :field-class="fieldClass"
      :value="_value"
      :name="name"
      :placeholder="placeholder"
      :type="type"
      :inputmode="inputmode"
      :size="size"
      :col="col"
      :disabled="disabled"
      :autocomplete="autocomplete"
      :empty-str-to-null="emptyStrToNull"
      :errors="[...errors, ...responseFieldErrors]"
      :hide-error-message="hideErrorMessage"
      v-on="$listeners" />
  </ValidationProvider>
</template>

<script>
import BaseTextField from '@/components/parts/BaseTextField.vue'
export default {
  name: 'BaseTextFieldWithProvider',
  components: {
    BaseTextField,
  },
  props: {
    value: {
      type: [String, Number],
      default: null
    },
    errors: {
      type: Array,
      default: () => []
    },
    col: {
      type: [String, Number],
      default: 12
    },
    type: {
      type: String,
      default: 'text' 
    },
    inputmode: {
      type: String,
      default: 'text' 
    },
    name: {
      type: String,
      default: undefined
    },
    placeholder: {
      type: String,
      default: undefined
    },
    emptyStrToNull: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    responseErrors: {
      type: Object,
      default: () => {}
    },
    errorTextColor: {
      type: String,
      default: 'primary'
    },
    vid: {
      type: String,
      default: null
    },
    rules: {
      type: [String, Array],
      default: undefined
    },
    fieldClass: {
      type: String,
      default: null
    },
    autocomplete: {
      type: String,
      default: undefined
    },
    size: {
      type: String,
      default: undefined
    },
    hideErrorMessage: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    _value: {
      get() {
        return this.value
      },
      set(v) {
        return this.$emit('input', v)
      }
    },
    responseFieldErrors() {
      return this.responseErrors?.[this.vid] || null
    }
  }
}
</script>

<style lang="scss" scoped>
.base-text-field {
  width: 100%;
  margin-bottom: 0;
}
</style>